module.exports = __webpack_public_path__ + "img/collect-free-masks-2.63577c41.png";